export class Cookies {
  constructor() {
    document.addEventListener('cookieyes_consent_update', () => {
      if (document.documentElement.lang == 'en-US') {
        const revisit = document.querySelector('.cky-revisit-hide');
        const overlay = document.querySelector('.cky-overlay');
        const reject = document.querySelector('.cky-btn-reject');
        const accept = document.querySelector('.cky-btn-accept');

        if (revisit) {
          overlay?.classList.remove('cky-hide');
        }

        reject?.addEventListener('click', () => {
          overlay?.classList.add('cky-hide');
        });

        accept?.addEventListener('click', () => {
          overlay?.classList.add('cky-hide');
        });
      }
    });
  }
}

export default new Cookies;
